export default function HeroSection() {
  return (
    <section className="hero" aria-label="Hero banner" id="home">
      <div className="hero-bg" aria-hidden="true" />
      <div className="hero-inner">
        <div className="hero-content-box">
          <div className="hero-eyebrow fade-up">
            FCO Certified - 100% Organic
          </div>
          <h1 className="hero-title fade-up delay-1">
            Grow Naturally.
            <em>Grow Stronger.</em>
          </h1>
          <p className="hero-sub fade-up delay-2">
            Premium organic fertilizers made from desi cow dung and earthworms - no chemicals, no compromises. Trusted by farmers and home gardeners across India.
          </p>
          <div className="hero-actions fade-up delay-3">
            <a href="/vermicompost" className="btn-gold">Shop Vermicompost</a>
            <a href="/vermiwash" className="btn-outline-green" style={{color:'rgba(255,255,255,0.85)',borderColor:'rgba(255,255,255,0.35)'}}>Shop Vermiwash</a>
          </div>
          <div className="hero-stats fade-up delay-4">
            <div>
              <div className="stat-num">100%</div>
              <div className="stat-label">Chemical Free</div>
            </div>
            <div>
              <div className="stat-num">FCO</div>
              <div className="stat-label">Gov. Certified</div>
            </div>
            <div>
              <div className="stat-num">2+</div>
              <div className="stat-label">Years of Trust</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
